<template>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm"
             :label-width="$i18n.locale==='zh-CN'?'120px':'200px'"
             class="step-form">
        <el-form-item :label="$t('train.name')" prop="name">
            <el-input v-model="ruleForm.name" :placeholder="$t('tip.name')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('train.type')" prop="type">
            <el-select v-model="ruleForm.type" collapse-tags :placeholder="$t('tip.trainingType')">
                <el-option :label="item.value" :value="item.id" v-for="item in trainTypeMenu"
                           :key="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('train.time')" required>
            <el-form-item prop="startTime">
                <el-date-picker
                    v-model="ruleForm.startTime"
                    type="date"
                    style="width: 225px"
                    :placeholder="$t('c.startDate')"
                    :picker-options="pickerOptions1"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span>{{ $t('c.to') }}</span>
                <el-date-picker
                    v-model="ruleForm.endTime"
                    type="datetime"
                    style="width: 225px"
                    format="yyyy-MM-dd HH:mm:ss"
                    class="input-without-padding"
                    :placeholder="$t('train.endDate')"
                    :picker-options="pickerOptions2"
                    value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
        </el-form-item>
        <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
            <el-select v-model="ruleForm.forLevel" collapse-tags :placeholder="$t('tip.operatorLevel')">
                <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                           :key="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('c.examType')" prop="form">
            <el-select v-model="ruleForm.form" collapse-tags :placeholder="$t('tip.examType')">
                <el-option :label="item.value" :value="item.id" v-for="item in examFormMenu"
                           :key="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="培训专题" prop="special">
            <el-select v-model="ruleForm.special" collapse-tags placeholder="请选择培训专题" clearable>
                <el-option :label="item.value" :value="item.id" v-for="item in trainSpecialMenu" :key="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="isNeedSignature">
            <template #label>
                <tip-label label="电子签名" tip="若开启，学员完成培训计划后需要手写签名" />
            </template>
            <el-switch
                v-model="ruleForm.isNeedSignature"
                active-text="开启"
                inactive-text="关闭">
            </el-switch>
        </el-form-item>
        <!-- <el-form-item :label="$t('train.classHour')" prop="period">
                           <el-input-number v-model="ruleForm.period" controls-position="right" :min="0"
                                            :max="400"></el-input-number>
                       </el-form-item> -->
        <el-form-item :label="$t('train.site')" prop="place">
            <el-input v-model="ruleForm.place" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('train.preTime')">
            <el-form-item prop="prePublishTime">
                <el-date-picker
                    type="datetime"
                    :placeholder="$t('tip.datetime')"
                    v-model="ruleForm.prePublishTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions3"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 100%;"></el-date-picker>
            </el-form-item>
        </el-form-item>
        <el-form-item :label="$t('train.content')" prop="content">
            <el-input type="textarea"
                      v-model="ruleForm.content"
                      :autosize="{ minRows: 2, maxRows: 4}"></el-input>
        </el-form-item>

    </el-form>
</template>

<script>
import {mapGetters} from 'vuex'
import dayjs from 'dayjs'

export default {
    components: {},

    data() {
        let validatePass = (rule, value, callback) => {
            if (value && new Date(value).getTime() < new Date().getTime()) {
                return callback(new Error(this.$t('rule.time')));
            }
            callback();
        }

        return {
            // 第一步的表单
            ruleForm: {
                name: '',
                form: '',
                isNeedSignature: false,
                startTime: '',
                endTime: '',
                forLevel: '',
                type: '',
                special: '',
                place: '',
                period: 0,
                prePublishTime: '',
                content: ''
            },
            // 表单验证
            rules: {
                name: [
                    {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                    {min: 2, max: 50, message: this.$t('rule.lengthBetween', ['2', '50']), trigger: 'blur'}
                ],
                form: [
                    {required: true, message: this.$t('tip.examType'), trigger: 'change'}
                ],
                forLevel: [
                    {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                ],
                startTime: [
                    {required: true, message: this.$t('tip.startTime'), trigger: 'change'}
                ],
                type: [
                    {required: true, message: this.$t('tip.trainingType'), trigger: 'change'}
                ],
                place: [
                    {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                ],
                prePublishTime: [
                    {validator: validatePass, trigger: 'blur'}
                ],
                content: [
                    {max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'}
                ],
            },
        }
    },

    computed: {
        ...mapGetters([
            'forLevelMenu',
            'trainTypeMenu',
            'examFormMenu',
            'trainSpecialMenu',
        ]),
        pickerOptions1() {
            let that = this;
            return {
                disabledDate(time) {
                    if (!that.ruleForm.endTime) return false;
                    return time.getTime() > new Date(that.ruleForm.endTime).getTime()
                },
            }
        },
        pickerOptions2() {
            let that = this;
            return {
                disabledDate(time) {
                    if (!that.ruleForm.startTime) return false;
                    return time.getTime() < new Date(that.ruleForm.startTime).setHours(0)
                },
            }
        },
        pickerOptions3() {
            return {
                disabledDate(time) {
                    const timeToValidate = time.getTime()
                    const lastDay = dayjs().subtract(1, 'day').valueOf()
                    const finalDay = dayjs().add(21, 'day').valueOf()
                    return (timeToValidate < lastDay) || (timeToValidate > finalDay)
                },
            }
        }
    },

    methods: {
        // 加载第一步数据
        fillData(data) {
            for (let item in data) {
                if (this.ruleForm.hasOwnProperty(item)) {
                    this.ruleForm[item] = data[item];
                }
            }
        },

        getData() {
            return {...this.ruleForm}
        },

        validate() {
            let isValid;
            this.$refs.ruleForm.validate((valid) => {
                isValid = valid
            });
            return isValid
        },

        clear() {
            for (let item in this.ruleForm) {
                this.ruleForm[item] = '';
            }
        }
    },
}
</script>

<style scoped lang="scss">
.step-form {
    width: 600px;
    margin-top: 40px;
    margin-left: 40px;
    padding-bottom: 30px;

    .el-select {
        width: 100%;
    }
}

</style>
